import * as React from 'react';

import { cn } from '@rematter/ui-web/lib';

type SpreadsheetCellProps = {
  children: React.ReactNode;
  focused?: boolean;
  className?: string;
  tdClassName?: string;
  onFocus?: () => void;
  onBlur?: (e: React.FocusEvent) => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
};

//
// ⚛️ ⚛️ ⚛️ SPREADSHEET CELL ⚛️ ⚛️ ⚛️
//
export const SpreadsheetCell = React.forwardRef<
  HTMLDivElement,
  SpreadsheetCellProps
>(
  (
    {
      children,
      focused: _focused,
      className,
      tdClassName,
      onFocus,
      onBlur,
      onKeyDown,
    },
    ref,
  ) => (
    <td className={cn('border border-neutral/20 p-0', tdClassName)}>
      <div
        ref={ref}
        tabIndex={-1}
        className={cn(
          'flex h-full min-h-[40px] w-full items-center outline-none',
          className,
        )}
        onFocus={onFocus}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
      >
        {children}
      </div>
    </td>
  ),
);
